import { useEffect, useState } from 'react';
import type ExportModel from '@/models/entities/ExportModel';
import { loadFilterNames, type FilterNames } from './exports';

/** Noms des périodes et équipes citées par les filtres des exports affichés (null pendant le chargement) */
export function useFilterNames(exports: ExportModel[]): FilterNames | null {
  const key = exports.map((model) => model.id).join(',');
  const [state, setState] = useState<{ key: string; names: FilterNames } | null>(null);

  useEffect(() => {
    if (!key) return;
    let active = true;
    loadFilterNames(exports)
      .then((names) => active && setState({ key, names }))
      .catch(() => active && setState({ key, names: { periods: new Map(), teams: new Map() } }));
    return () => {
      active = false;
    };
    // exports : suivis par leurs ids (key)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return state?.key === key ? state.names : null;
}
